{
  "SIN": "Numéro d'assurance sociale",
  "BN": "numéro d'entreprise",
  "SSN": "Numéro de sécurité sociale",
  "EIN": "Numéro d'identification de l'employeur",
  "ITIN": "Numéro d'identification du contribuable individuel",
  "GENERIC": "Numéro d'identification fiscale",
  "abbreviated": {
    "SIN": "NAS",
    "BN": "NE",
    "SSN": "SSN",
    "EIN": "EIN",
    "ITIN": "ITIN",
    "GENERIC": "NIF"
  }
}
